import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { DirectoryContext } from '../../contexts/DirectoryContext'
import InputMask from 'react-input-mask';

import './UpdateListingForm.css'
import { Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, Select, TextField, Button, MenuItem, InputLabel, FormControl, ButtonGroup, Input } from '@mui/material'
import { UpdateListingFormContext } from '../../contexts/UpdateListingFormContext'

function UpdateListingForm({ listing }) {
    const {
        errors,
        updateListing,
        handleChange,
        handlePlanChange,
        handleListingTypeChange,
        handleSubmit,
        showSuccess,
        showErrors,
        showLoading,
        apiResponseMessage,
        handleFileChange,
    } = useContext(UpdateListingFormContext);

    const {
        stateOptions,
        countryOptions,
        listingPlans,
        categoryOptions,
        subCategoryOptions,
    } = useContext(DirectoryContext);

    const imageSrc = `data:image/jpeg;base64,${updateListing.Picture}`;


    useEffect(() => {
        if (listing) {
            Object.keys(listing).forEach(key => {
                if (updateListing[key] !== listing[key]) {
                    handleChange({ target: { name: key, value: listing[key] || '' } });
                }
            });
        }
    }, [listing]);

    return (
        <div className='updatelistingform-container'>
            <Form className='updatelistingform-form'>
                <Row className='text-center mt-5'>
                    <Col>
                        <ButtonGroup className='updatelistingform-buttongroup' variant='text'>
                            {listingPlans.map((plan, index) => (
                                <Button
                                    key={index}
                                    onClick={handlePlanChange}
                                    name='planOption'
                                    value={plan.Code}>
                                    {plan.Name}
                                </Button>
                            ))}
                        </ButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h1>
                            {listingPlans.find(x => x.Code === updateListing.planOption)?.Name} Listing Information
                        </h1>
                        <p>
                            Please enter the required (*) listing information below. Your request will then be processed
                            and you will be contacted for payment.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Category Type</InputLabel>
                            <Select
                                id='CategoryID'
                                name='CategoryID'
                                variant='filled'
                                label='CategoryID'
                                margin='dense'
                                error={!!errors.CategoryID}
                                helpertext={errors.CategoryID}
                                value={updateListing.CategoryID}
                                onChange={handleListingTypeChange}>
                                {
                                    categoryOptions.map((category, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={category.ID}>
                                                {category.Name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Subcategory Type</InputLabel>
                            <Select
                                id='SubCategoryID'
                                name='SubCategoryID'
                                variant='filled'
                                label='SubCategoryID'
                                margin='dense'
                                error={!!errors.SubCategoryID}
                                helpertext={errors.SubCategoryID}
                                value={updateListing.SubCategoryID}
                                onChange={handleChange}>
                                {
                                    (subCategoryOptions || [])
                                        .filter(subcategory => subcategory.CategoryID === updateListing.CategoryID)
                                        .map((subcategory, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={subcategory.ID}>
                                                    {subcategory.Name}
                                                </MenuItem>
                                            )
                                        })
                                }
                            </Select>
                        </FormControl>
                    </Col>
                </Row>
                {
                    ((['5', '6'].includes(updateListing.CategoryID.toString())) ||
                        (['1'].includes(updateListing.CategoryID.toString())) && (['2'].includes(updateListing.SubCategoryID.toString()))) &&
                    <Row>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='FirstName'
                                name='FirstName'
                                label='First Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.FirstName}
                                helpertext={errors.FirstName}
                                value={updateListing.FirstName || ''}
                                onChange={handleChange} />
                        </Col>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='LastName'
                                name='LastName'
                                label='Last Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.LastName}
                                helpertext={errors.LastName}
                                value={updateListing.LastName || ''}
                                onChange={handleChange} />
                        </Col>
                    </Row>
                }
                {
                    ((['2', '3', '4'].includes(updateListing.CategoryID.toString())) ||
                        (['1'].includes(updateListing.CategoryID.toString())) && (['1'].includes(updateListing.SubCategoryID.toString()))) &&
                    <Row>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='OrganizationName'
                                name='OrganizationName'
                                label='Organization Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.OrganizationName}
                                helpertext={errors.OrganizationName}
                                value={updateListing.OrganizationName || ''}
                                onChange={handleChange}
                            />
                        </Col>
                        <Col>
                            <TextField
                                fullWidth={true}
                                id='OwnerName'
                                name='OwnerName'
                                label='Owner Name'
                                type='text'
                                variant='filled'
                                margin='dense'
                                error={!!errors.OwnerName}
                                helpertext={errors.OwnerName}
                                value={updateListing.OwnerName || ''}
                                onChange={handleChange}
                            />
                        </Col>
                    </Row>
                }

                <Row>
                    <Col>
                        {
                            (updateListing.CategoryID === 5 || updateListing.CategoryID === 6) && updateListing.PositionTitle != null
                                ? <TextField
                                    fullWidth={true}
                                    id='PositionTitle'
                                    name='PositionTitle'
                                    label='PositionTitle'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.PositionTitle}
                                    helperText={errors.PositionTitle}
                                    value={updateListing.PositionTitle || ''}
                                    onChange={handleChange} />
                                : <TextField
                                    fullWidth={true}
                                    id='Prefix'
                                    name='Prefix'
                                    label='Prefix'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.Prefix}
                                    helperText={errors.Prefix}
                                    value={updateListing.Prefix || ''}
                                    onChange={handleChange} />
                        }
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='CustomerNumber'
                            name='CustomerNumber'
                            label='AJCA Customer Number'
                            type='number'
                            variant='filled'
                            margin='dense'
                            error={!!errors.CustomerNumber}
                            helpertext={errors.prefix}
                            value={updateListing.CustomerNumber}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={updateListing.HomePhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='HomePhone'
                                    name='HomePhone'
                                    label='Home Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.HomePhone}
                                    helpertext={errors.HomePhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={updateListing.WorkPhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='WorkPhone'
                                    name='WorkPhone'
                                    label='Work Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.WorkPhone}
                                    helpertext={errors.WorkPhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={updateListing.CellPhone || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='CellPhone'
                                    name='CellPhone'
                                    label='Cell Phone'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.CellPhone}
                                    helpertext={errors.CellPhone}
                                />
                            )}
                        </InputMask>
                    </Col>
                    <Col>
                        <InputMask
                            mask="(999)999-9999"
                            value={updateListing.Fax || ''}
                            onChange={handleChange}
                            maskChar=""
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    fullWidth={true}
                                    id='Fax'
                                    name='Fax'
                                    label='Fax'
                                    type='text'
                                    variant='filled'
                                    margin='dense'
                                    error={!!errors.Fax}
                                    helpertext={errors.Fax}
                                />
                            )}
                        </InputMask>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Email'
                            name='Email'
                            label='Email'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.Email}
                            helpertext={errors.Email}
                            value={updateListing.Email}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h3>Address</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>Country</InputLabel>
                            <Select
                                fullWidth={true}
                                id='CountryID'
                                name='CountryID'
                                variant='filled'
                                label='CountryID'
                                margin='dense'
                                error={!!errors.CountryID}
                                helpertext={errors.CountryID}
                                value={updateListing.CountryID}
                                onChange={handleChange}>
                                {
                                    countryOptions.map((country, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={country.UnCode}>
                                                {country.Name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='City'
                            name='City'
                            label='City'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.City}
                            helpertext={errors.City}
                            value={updateListing.City}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <FormControl
                            variant='filled'
                            fullWidth={true}
                            margin='dense'>
                            <InputLabel>State</InputLabel>
                            <Select
                                fullWidth={true}
                                id='StateProvince'
                                name='StateProvince'
                                label='State'
                                variant='filled'
                                value={updateListing.StateProvince}
                                onChange={handleChange}>
                                <option>Select a State</option>
                                {
                                    stateOptions.map((state, index) => {
                                        return (
                                            <MenuItem
                                                key={index}
                                                value={state.Name}>
                                                {state.Name}
                                            </MenuItem>
                                        )
                                    })

                                }
                            </Select>
                        </FormControl>
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='ZipCode'
                            name='ZipCode'
                            label='Zip Code'
                            variant='filled'
                            type='number'
                            margin='dense'
                            error={!!errors.ZipCode}
                            helpertext={errors.ZipCode}
                            value={updateListing.ZipCode}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Address1'
                            name='Address1'
                            label='Address Line 1'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.Address1}
                            helpertext={errors.Address1}
                            value={updateListing.Address1}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Address2'
                            name='Address2'
                            label='Address Line 2'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.Address2}
                            helpertext={errors.Address2}
                            value={updateListing.Address2}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <TextField
                            fullWidth={true}
                            id='LocationDescription'
                            name='LocationDescription'
                            label='Location Description'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.LocationDescription}
                            helpertext={errors.LocationDescription}
                            value={updateListing.LocationDescription}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                        <h3>Additional Options</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='CowCount'
                            name='CowCount'
                            label='Number Milking Cows'
                            type='number'
                            variant='filled'
                            margin='dense'
                            error={!!errors.CowCount}
                            helpertext={errors.CowCount}
                            value={updateListing.CowCount}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='WebsiteUrl'
                            name='WebsiteUrl'
                            label='Website URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.WebsiteUrl}
                            helpertext={errors.WebsiteUrl}
                            value={updateListing.WebsiteUrl}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='YoutubeUrl'
                            name='YoutubeUrl'
                            label='Youtube URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.YoutubeUrl}
                            helpertext={errors.YoutubeUrl}
                            value={updateListing.YoutubeUrl}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='FacebookUrl'
                            name='FacebookUrl'
                            label='Facebook URL'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.FacebookUrl}
                            helpertext={errors.FacebookUrl}
                            value={updateListing.FacebookUrl}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='LinkedInUrl'
                            name='LinkedInUrl'
                            label='LinkedIn URL'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.LinkedInUrl}
                            helpertext={errors.LinkedInUrl}
                            value={updateListing.LinkedInUrl}
                            onChange={handleChange} />
                    </Col>
                    <Col>
                        <TextField
                            fullWidth={true}
                            id='InstagramUrl'
                            name='InstagramUrl'
                            label='Instagram URL'
                            variant='filled'
                            type='text'
                            margin='dense'
                            error={!!errors.InstagramUrl}
                            helpertext={errors.InstagramUrl}
                            value={updateListing.InstagramUrl}
                            onChange={handleChange} />
                    </Col>
                </Row>
                <Row>
                    <Col>

                        <TextField
                            fullWidth={true}
                            id='FarmMessage'
                            name='FarmMessage'
                            label='Farm Message'
                            type='text'
                            variant='filled'
                            margin='dense'
                            error={!!errors.FarmMessage}
                            helpertext={errors.FarmMessage}
                            value={updateListing.FarmMessage}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>

                    <Col>
                        <TextField
                            fullWidth={true}
                            id='Notes'
                            name='Notes'
                            label='Notes'
                            type='text'
                            margin='dense'
                            variant='filled'
                            error={!!errors.Notes}
                            helpertext={errors.Notes}
                            value={updateListing.Notes}
                            onChange={handleChange}
                            multiline={true}
                            rows={3} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RadioGroup
                            value={updateListing.PerformanceProgram || 'NONE'}
                            onChange={handleChange}
                            name="PerformanceProgram" >
                            <FormControlLabel value='NONE' control={<Radio />} label='None' />
                            <FormControlLabel value='REAP' control={<Radio />} label='REAP (Basic or Plus)' />
                            <FormControlLabel value='TPE' control={<Radio />} label='TPE (Basic or Plus)' />
                            <FormControlLabel value='FLAIR' control={<Radio />} label='FLAIR' />
                            <FormControlLabel value='PERF' control={<Radio />} label='Performance Records' />
                        </RadioGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={<Checkbox id='EquityInvestor' name='EquityInvestor' checked={updateListing.EquityInvestor === true} onChange={handleChange} />}
                                label='Equity Investor'
                            />
                            <FormControlLabel
                                control={<Checkbox id='HeiferGrowerOnly' name='HeiferGrowerOnly' checked={updateListing.HeiferGrowerOnly === true} onChange={handleChange} />}
                                label='Heifer Grower Only'
                            />
                        </FormGroup>
                    </Col>
                    <Col>
                        <FormGroup>
                            <Button variant="contained" component="label">
                                Upload File
                                <input
                                    type="file"
                                    onChange={handleFileChange}
                                    accept=".jpg,.jpeg"
                                    hidden 
                                />
                            </Button>
                            <p>Please enter a farm logo, or email it to journal and they will format and put it in for you.</p>
                            {updateListing.Picture ? (
                                <div className='newListing-media'>
                                    <img
                                        height={300}
                                        width={450}
                                        src={imageSrc}
                                        alt="Uploaded farm logo"
                                    />
                                </div>
                            ) : (
                                <></>
                            )}
                            {errors.Picture && <p style={{ color: 'red' }}>{errors.Picture}</p>}
                        </FormGroup>

                        <Col>
                            <FormControlLabel
                                control={<Checkbox id='IsActive' name='IsActive' checked={updateListing.IsActive === true} onChange={handleChange} />}
                                label='Active Listing'
                            />
                        </Col>
                        <Col>
                            <FormControlLabel
                                control={<Checkbox id='QueenOfQuality' name='QueenOfQuality' checked={updateListing.QueenOfQuality === true} onChange={handleChange} />}
                                label='Queen of Quality'
                            />
                        </Col>
                        <Col>
                            <FormControlLabel
                                control={<Checkbox id='Complimentary' name='Complimentary' checked={updateListing.Complimentary === true} onChange={handleChange} />}
                                label='Complimentary Listing'
                            />
                        </Col>
                    </Col>
                </Row>
                <Row className='mt-5'>
                    <Col>
                        <Button type="submit" variant='contained' onClick={handleSubmit}>
                            Submit
                        </Button>
                        {showSuccess && <p style={{ color: 'green' }}>Form submitted successfully!</p>}
                        {showErrors && (
                            <div>
                                <p style={{ color: 'red' }}>There were errors submitting the form:</p>
                                {Object.values(errors).filter(error => error !== '').map((error, index) => (
                                    <p key={index} style={{ color: 'red' }}>{error}</p>
                                ))}
                            </div>
                        )}
                        {showLoading && <p>Submitting...</p>}
                        {apiResponseMessage && <p>{apiResponseMessage}</p>}
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default UpdateListingForm